import { getHttpStatusFromError, getQueryErrorMessage } from 'utils/httpError';

// What a failed request says, with its HTTP status when it has one, so support can tell a server error from a
// network failure or an expired session.
export const describeExportFailure = (error: unknown, fallback: string): string => {
  const message = getQueryErrorMessage(error, fallback);
  const status = getHttpStatusFromError(error);
  return status ? `HTTP ${status}: ${message}` : message;
};

export interface ExportErrorReportInput {
  operation: string;
  studyId?: string;
  labId?: string;
  // Which results were being exported, for example `Post-processing runs: a, b`.
  source: string;
  errors: string[];
  now?: Date;
}

// Plain text a user can paste into a support request. It names the study, lab and results the export was reading,
// and every error, so support does not have to ask for them.
export const buildExportErrorReport = ({
  operation,
  studyId,
  labId,
  source,
  errors,
  now = new Date(),
}: ExportErrorReportInput): string =>
  [
    'Nucleai support reference',
    `Operation: ${operation}`,
    `Study: ${studyId ?? 'unknown'}`,
    `Lab: ${labId ?? 'unknown'}`,
    `Results: ${source}`,
    `Time (UTC): ${now.toISOString()}`,
    'Errors:',
    ...errors.map((error) => `- ${error}`),
  ].join('\n');
